import axios from "../../../axios"
import { getCurrentTenant, parseObjectParamsToString } from '@/utils'

export default {
  fetch(userId) {
    const searchParams = {
      user_id: userId,
      is_read: false
    }

    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          userNotifications ${parseObjectParamsToString(searchParams)} {
            id,
            title,
            text,
            is_read,
            video_url,
            created_at
          }
        }
      `
    })
  },
  read(notificationd) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          readUserNotification(
            id: ${notificationd}
          ) {
            id
          }
        }
      `
    })
  }
}
